'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var PropTypes = _interopRequireWildcard(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNKNOWN_PROPS = ['sources', 'width', 'height', 'flexible', 'fit', 'fitFallback'];
var POSITIVE_INTEGER_PATTERN = /^\d+$/;

/**
 * React component that render a image with object-fit and its fallback
 *
 * @class SuperImage
 */

var SuperImage = function (_React$Component) {
  _inherits(SuperImage, _React$Component);

  function SuperImage() {
    _classCallCheck(this, SuperImage);

    return _possibleConstructorReturn(this, (SuperImage.__proto__ || Object.getPrototypeOf(SuperImage)).apply(this, arguments));
  }

  _createClass(SuperImage, [{
    key: 'renderImage',
    value: function renderImage() {
      var _this2 = this;

      var style = {};
      var props = {};

      if (this.props.fit) {
        style.objectFit = this.props.fit;
      }

      if (this.props.flexible) {
        style.width = '100%';
        style.height = '100%';
      } else {
        if (POSITIVE_INTEGER_PATTERN.test(this.props.width)) {
          style.width = this.props.width + 'px';
        } else if (this.props.width) {
          style.width = this.props.width;
        }

        if (POSITIVE_INTEGER_PATTERN.test(this.props.height)) {
          style.height = this.props.height + 'px';
        } else if (this.props.height) {
          style.height = this.props.height;
        }
      }

      // Props given to this Component is inherited <img /> in all
      Object.keys(this.props).filter(function (key) {
        return UNKNOWN_PROPS.indexOf(key) === -1;
      }).forEach(function (key) {
        props[key] = _this2.props[key];
      });

      // If `alt` is not empty, `none` or `presentation` can not be specified.
      // So delete the `role` attribute.
      // @see https://www.w3.org/TR/html-aria/#img-alt
      if (props.alt && props.role !== 'img') {
        props.role = null;
      }

      // Render picture element if `sources` property exists
      if (this.props.sources.length > 0) {
        var pictureStyle = this.props.flexible ? {
          width: '100%',
          height: '100%'
        } : {};

        /* eslint-disable react/no-array-index-key */
        var sources = this.props.sources.map(function (source, i) {
          return React.createElement('source', _extends({ key: i }, source));
        });
        /* eslint-disable react/no-array-index-key */

        return React.createElement(
          'picture',
          { style: pictureStyle },
          sources,
          React.createElement('img', _extends({
            src: this.props.src,
            alt: this.props.alt,
            style: style
          }, props))
        );
      }

      return React.createElement('img', _extends({
        src: this.props.src,
        alt: this.props.alt,
        style: style
      }, props));
    }
  }, {
    key: 'renderImageWithObjectFitFallback',
    value: function renderImageWithObjectFitFallback() {
      var style = {
        display: 'inline-block',
        backgroundImage: 'url(' + this.props.src + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center'
      };

      if (this.props.flexible) {
        style.width = '100%';
        style.height = '100%';
      } else {
        if (POSITIVE_INTEGER_PATTERN.test(this.props.width)) {
          style.width = this.props.width + 'px';
        } else if (this.props.width) {
          style.width = this.props.width;
        }

        if (POSITIVE_INTEGER_PATTERN.test(this.props.height)) {
          style.height = this.props.height + 'px';
        } else if (this.props.height) {
          style.height = this.props.height;
        }
      }

      if (this.props.fit) {
        style.backgroundSize = this.props.fit;
      }

      return React.createElement('div', {
        role: this.props.alt ? 'img' : this.props.role || 'img',
        'aria-label': this.props.alt,
        className: this.props.className,
        style: style
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.fitFallback) {
        return this.renderImageWithObjectFitFallback();
      }

      return this.renderImage();
    }
  }]);

  return SuperImage;
}(React.Component);

SuperImage.propTypes = {
  src: PropTypes.string.isRequired,
  sources: PropTypes.arrayOf(PropTypes.shape({
    srcSet: PropTypes.string,
    sizes: PropTypes.string,
    media: PropTypes.string,
    type: PropTypes.string
  })),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  alt: PropTypes.string,
  role: PropTypes.oneOf(['none', 'presentation']),
  className: PropTypes.string,
  fit: PropTypes.oneOf(['contain', 'cover']),
  fitFallback: PropTypes.bool,
  flexible: PropTypes.bool
};
SuperImage.defaultProps = {
  sources: [],
  width: null,
  height: null,
  alt: '',
  role: null,
  className: '',
  fit: null,
  fitFallback: false,
  flexible: false
};
exports.default = SuperImage;